import React, { useRef } from "react";

import BaseQuestionCard from "../BaseQuestionCard";
import ChoiceOptionsEditor from "../utils/ChoiceOptionsEditor";
import {
  QUESTION_CARD_VARIANTS,
  SURVEY_TYPES,
  MULTIPLE_CHOICE_QUESTION_DEFAULTS
} from "../constants/constantsSurveys";

const isDefaultOptionLabel = (label, index) => {
  return (label || "").trim() === `Opción ${index + 1}`;
};

export default function MultipleChoiceQuestion(props) {
  const { question, onUpdate } = props;

  const inputRefs = useRef([]);

  const options =
    question.options && question.options.length > 0
      ? question.options
      : Array.from({ length: MULTIPLE_CHOICE_QUESTION_DEFAULTS.initialOptionsCount }, () => ({
          id: crypto.randomUUID(),
          label: ""
        }));

  const handleOptionChange = (optionIndex, value) => {
    const newOptions = [...options];
    newOptions[optionIndex] = {
      ...newOptions[optionIndex],
      label: value
    };

    onUpdate({ options: newOptions });
  };

  const handleAddOption = () => {
    const newOptions = [
      ...options,
      {
        id: crypto.randomUUID(),
        label: ""
      }
    ];

    onUpdate({ options: newOptions });

    setTimeout(() => {
      const index = newOptions.length - 1;
      inputRefs.current[index]?.focus();
    }, 0);
  };

  const handleDeleteOption = (optionIndex) => {
    if (options.length <= 1) return;

    const newOptions = options.filter((_, index) => index !== optionIndex);

    onUpdate({ options: newOptions });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddOption();
    }
  };

  const getInputValue = (option, optionIndex) => {
    return isDefaultOptionLabel(option.label, optionIndex)
      ? ""
      : option.label || "";
  };

  const optionsContent = (
    <ChoiceOptionsEditor
      type={SURVEY_TYPES.multipleChoice}
      options={options}
      inputRefs={inputRefs}
      getInputValue={getInputValue}
      onOptionChange={handleOptionChange}
      onOptionKeyDown={handleKeyDown}
      onAddOption={handleAddOption}
      onDeleteOption={handleDeleteOption}
      shouldValidate={question.shouldValidate}
    />
  );

  return (
    <BaseQuestionCard
      {...props}
      {...QUESTION_CARD_VARIANTS[SURVEY_TYPES.multipleChoice]}
      extraContent={optionsContent}
    />
  );
}